<template>
	<div style="width:20vw;height:100%;">
		<div class="xj">
			<div class="i_top">{{id}}<span class="time">{{time}}</span></div>
			<!-- ：、、、、、、。
			测点显示：设备编码、设备名称、设备分类、设备位置、设备照片、设备资料、监测数据。-->
			<div class="i_content i_content_white" v-for="(item,index) in infoList" :key="index">
				<el-row>
                    <el-col class="i_content_name" :span="14">{{item.alias}}</el-col>
                    <el-col class="i_content_value word_green" :span="6" :style="{
                    color:
                      item.colour == 'green'
                        ? '#4DCB73'
                        : item.colour == 'red'
                        ? 'rgba(224, 32, 32, 1)'
                        : item.colour == 'yellow'
                        ? 'yellow'
                        : '',
                  }">{{item.value}} {{item.unit}}</el-col>
					 <!-- {{item.unitOrDescription}} -->
                </el-row>
			</div>
		</div>
	</div>
</template>

<script>
import DataService from '@/api/data';
export default {
	props: {
		id:String
	},
	data() {
		return {
			serialNumber:'',
			equipmentModel:'',
			infoList:[],
			time:''
		}
	},
	methods:{
		componentDataOf3D(id){
			DataService.componentDataOf3D({
				serialNumber:this.serialNumber,
				equipmentModel:this.equipmentModel,
				componentName:id
			}).then(res=>{
				this.infoList = res.data.list;
				this.time = res.data.date;
			}).catch(err=>{
				this.$message.error(err.message)
			})
		}
	},
	created(){
        if(this.$route.query.serial_number){
            this.serialNumber = this.$route.query.serial_number;
            this.equipmentModel = this.$route.query.equipment_model;
        }
    },
	mounted() {
		
	},
}
</script>

<style  scoped>
.i_top {
	text-align: left;
	font-size: 2vh;
	margin: 2vh;
	font-weight: 300;
	color: white;
	text-shadow: 3px 3px 3px #000000;
}

.i_content {
	margin-left: 1vh;
	padding-bottom: 2vh;
	line-height: 2vh;
}

.i_content_name {
	text-align: right;
	*width: 110px;
	float: left;
	font-size: 1.6vh;
	color: #cbc9c9;
}

.i_content_value {
	text-align: left;
	*width: 110px;
	float: left;
	margin-left: 2vh;
	margin-right: 2vh;
	margin-bottom: 0px;
	font-size: 1.6vh;
	color: #2da8cf;
	font-weight: 900;
}
.time{
	font-size: 16px;
	margin-left: 10px;
}
</style>